// ** Icons Import
import {GitPullRequest, MapPin, Trello, BarChart2} from 'react-feather'
import {AiOutlineBarChart} from "react-icons/all"
import {AiOutlineLineChart} from "react-icons/ai"

export default [
    {
        header: 'navigation.report',
        action: 'ROLE_REPORT_',
        resource: 'IS_GRANTED'
    },
    {
        id: 'report-entry-exit-event-report',
        title: 'navigation.entry_exit_event',
        icon: <GitPullRequest size={20}/>,
        navLink: '/report/entry-exit',
        action: 'ROLE_REPORT_ENTRY_EXIT_EVENT',
        resource: 'IS_GRANTED'
    },
    {
        id: 'report-gate-event-report',
        title: 'navigation.gate_event',
        icon: <Trello size={20}/>,
        navLink: '/report/gate-event',
        action: 'ROLE_REPORT_GATE_EVENT',
        resource: 'IS_GRANTED'
    },
    {
        id: 'report-driver-load-report',
        title: 'navigation.driver_load',
        icon: <AiOutlineBarChart size={20}/>,
        navLink: '/report/driver-load',
        action: 'ROLE_REPORT_DRIVER_LOAD',
        resource: 'IS_GRANTED'
    },
    {
        id: 'report-parking-load-report',
        title: 'navigation.parking_load',
        icon: <AiOutlineLineChart size={20}/>,
        navLink: '/report/parking-load',
        action: 'ROLE_REPORT_PARKING_LOAD',
        resource: 'IS_GRANTED'
    },
    {
        id: 'report-customer-report',
        title: 'navigation.customers_location',
        icon: <MapPin size={20}/>,
        navLink: '/report/customer-location',
        action: 'ROLE_REPORT_CUSTOMER_LOCATION',
        resource: 'IS_GRANTED'
    },
    {
        id: 'report-manager',
        title: 'navigation.manager_report',
        icon: <BarChart2 size={20}/>,
        navLink: '/report/manager',
        action: 'ROLE_REPORT_CUSTOMER_LOCATION',
        resource: 'IS_GRANTED'
    }
]